<h1 mat-dialog-title>Email Required</h1>

<div mat-dialog-content>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <form (ngSubmit)="saveEmailForm(emailForm)" [formGroup]="emailForm">
          <h6 style="color: red">Enter the email address:*</h6>
          <div class="form-group">
            <input
              type="email"
              title="Email"
              class="form-control"
              formControlName="email"
              aria-describedby="emailHelp"
            />
          </div>
          <button
            role="button"
            aria-label="Submit"
            type="submit"
            class="btn btn-primary"
            [disabled]="!emailForm.valid"
          >
            Send
          </button>
          <button
            role="button"
            aria-label="Submit"
            type="button"
            class="btn btn-primary"
            (click)="close()"
          >
            Cancel
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
